"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationErrorPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var Header_1 = require("../navigator/Header");
var Footer_1 = require("../navigator/Footer");
var ApplicationErrorPage = /** @class */ (function (_super) {
    __extends(ApplicationErrorPage, _super);
    function ApplicationErrorPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ApplicationErrorPage.prototype.render = function () {
        var params = new URLSearchParams(window.location.search);
        var error = params.get('e');
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(Header_1.Header, {}), (0, jsx_runtime_1.jsx)("div", { className: "journey-content error-page", children: (0, jsx_runtime_1.jsx)("div", { className: "journey-questions", children: (0, jsx_runtime_1.jsxs)("div", { className: "panel", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-center text-uppercase mt-2 mb-0 error-title", children: "Application error" }), (0, jsx_runtime_1.jsx)("img", { className: "d-block mx-auto mb-5", src: "/".concat(services_1.resourcesHelper.THEME, "/img/Flourish-error.svg"), alt: "Error" }), (0, jsx_runtime_1.jsx)("h2", { className: "text-center mt-3 mb-5 error-text", children: error || 'We are experiencing some technical issues, please come back later' })] }) }) }), (0, jsx_runtime_1.jsx)(Footer_1.Footer, {})] }));
    };
    return ApplicationErrorPage;
}(React.Component));
exports.ApplicationErrorPage = ApplicationErrorPage;
//# sourceMappingURL=ApplicationErrorPage.js.map